// 性能监控
import { clearLcpApiLogs, disableLcpApiLogs, getLcpApiLogs } from '@/common/lcp-api-logs';
import { onFCP, onLCP, onTTFB } from 'web-vitals';
import { onCLS, onINP } from 'web-vitals/attribution';

function getNetworkSnapshot() {
  const c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const nav = performance.getEntriesByType('navigation')[0];

  return {
    net_online: navigator.onLine,
    net_effective_type: c?.effectiveType || '',
    net_rtt: Number.isFinite(c?.rtt) ? c.rtt : -1,
    net_downlink: (() => {
      if (!nav) return Number.isFinite(c?.downlink) ? c.downlink : -1;
      const size = nav.transferSize || nav.encodedBodySize || 0;
      const duration = nav.responseEnd - nav.responseStart;
      if (size > 0 && duration > 0) {
        return parseFloat(((size * 8) / (duration * 1000)).toFixed(2));
      }
      return Number.isFinite(c?.downlink) ? c.downlink : -1;
    })(),
    net_save_data: !!c?.saveData,
    nav_ttfb: nav ? Math.round(nav.responseStart - nav.requestStart) : -1,
    nav_dns: nav ? Math.round(nav.domainLookupEnd - nav.domainLookupStart) : -1,
    nav_tcp: nav ? Math.round(nav.connectEnd - nav.connectStart) : -1,
    nav_tls:
      nav && nav.secureConnectionStart > 0
        ? Math.round(nav.connectEnd - nav.secureConnectionStart)
        : -1,
    nav_download: nav ? Math.round(nav.responseEnd - nav.responseStart) : -1,
  };
}
export default defineNuxtPlugin(() => {
  /**
   * @TrackType sensorsdata
   * @EventType FrontendPerformance_monitor
   * @EventDesc 前端性能指标监测
   * @EventParams {
   *  xn_page_type:页面类型
   *  xn_type:事件类型
   *  xn_value:事件值
   *  xn_id:指标ID
   *  xn_delta:事件 delta
   *  xn_data:事件数据
   *  xn_page_visible:页面可见状态
   * }
   * @Tapd 1009440
   */
  const SDFrontendPerformanceMonitor = (params) => {
    try {
      const sdEventName = 'FrontendPerformance_monitor';
      let sdEventParams = {
        xn_page_type: params.page_type,
        xn_type: params.type,
        xn_value: params.value,
        xn_id: params.xn_id,
        xn_delta: params.delta,
        xn_data: params.data,
        xn_page_visible: document.visibilityState,
        xn_dpr: window.devicePixelRatio,
        xn_viewport_w: window.innerWidth,
        xn_viewport_h: window.innerHeight,
        xn_is_spider: window.__isSpider__,
      };
      if (params.type === 'LCP') {
        const networkSnapshot = getNetworkSnapshot();
        const apiLogs = getLcpApiLogs(params.value);
        sdEventParams = {
          ...sdEventParams,
          ...networkSnapshot,
          xn_is_weak_network: (() => {
            const weakBySpeed =
              networkSnapshot.net_downlink > 0 && networkSnapshot.net_downlink < 1.5;
            const weakByType = ['slow-2g', '2g', '3g'].includes(networkSnapshot.net_effective_type);
            const weakByRtt = networkSnapshot.net_rtt > 0 && networkSnapshot.net_rtt > 500;
            return weakBySpeed || weakByType || weakByRtt;
          })(),
          ...(apiLogs.length > 0 ? { xn_api_log: JSON.stringify(apiLogs) } : {}),
        };
        clearLcpApiLogs();
        disableLcpApiLogs();
      }
      window.voo_sensors.sensorsTrack(sdEventName, sdEventParams);
    } catch (e) {
      console.log(e);
    }
  };

  const sendPoint = function (data) {
    try {
      const pathname = window.location.pathname || '';
      const page_type =
        pathname === '/'
          ? 1
          : pathname.includes('/goods-list/')
            ? 2
            : pathname.includes('/goods-detail/')
              ? 3
              : 0;
      if (page_type === 0) return;
      const value = Math.round(data.name === 'CLS' ? data.value * 1000 : data.value);
      let sendData = {};
      if (['CLS', 'INP'].includes(data.name)) {
        console.warn('perf===', data);
        const { attribution } = data;
        sendData = {
          name: data.name,
          value,
          target:
            data.name === 'CLS' ? attribution.largestShiftTarget : attribution.interactionTarget,
        };
      }
      const params = {
        page_type,
        type: data.name,
        value,
        xn_id: data.id,
        event_name: data.name,
        metric_value: value,
        data: JSON.stringify(sendData),
      };
      console.log('perf===', params, data);
      SDFrontendPerformanceMonitor(params);
    } catch (error) {
      console.log(error);
    }
  };
  onCLS(sendPoint);
  onFCP(sendPoint);
  onINP(sendPoint, {
    reportAllChanges: true,
  });
  onLCP(sendPoint);
  onTTFB(sendPoint);
});
